<svelte:options accessors/>
<script>
    import {onMount, createEventDispatcher} from "svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import NauiDatePicker from "../../../naui/atoms/NauiDatePicker.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiFloatingAction from "../../../naui/components/NauiFloatingAction.svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiTabs from "../../../naui/components/NauiTabs.svelte";
    import InformacionDesiste from "./InformacionDesiste.svelte";
    import LogisticaTransporte from "./LogisticaTransporte.svelte";
    import TipoEmbalaje from "../../servicio/TipoEmbalaje.svelte";
    import MueblesEspeciales from "./MueblesEspeciales.svelte";
    import TamanoServicio from "./TamanoServicio.svelte";
    import DesisteSlideover from "./DesisteSlideover.svelte";
    import Legalizacion from "./Legalizacion.svelte";
    import Galeria from "../Galeria.svelte";

    const events = new createEventDispatcher();

    export let urlCotizacion = '';
    export let urlDesiste = '';
    export let urlResponsable = '';
    export let urlGaleria = '';

    export let isNew;
    export let isActive = true;
    export let isService = false;
    export let visualizacion = false;
    export let data;
    export let options;
    export let tabsImagenes = [];

    let openSlideoverDesiste = false;
    let openSlideoverImagenes = false;
    let activeImageTab = '';

    $: logistic = data ? data.servicios.transporte ||
        data.servicios.embalaje ||
        data.servicios.domicilio_cajas ||
        data.servicios.movimiento_bodegas : false;

    $: viewCaption = visualizacion ? 'QUITAR DE VISUALIZACIÓN' : 'AGREGAR A VISUALIZACIÓN';

    onMount(() => {
        if (!isNew) {
            submitData({}, 'get', urlGaleria).then((res) => {
                tabsImagenes = res.tabs;
                if (tabsImagenes.length > 0) {
                    activeImageTab = tabsImagenes[0].slug;
                }
            });
        }
    });

    function cambioCheckboxBusquedaWeb() {
        if (data.medio_contacto.busqueda_web) {
            data.medio_contacto.como_busco = '';
        }
    }

    function cambioCheckboxReferido() {
        if (data.medio_contacto.referido) {
            data.medio_contacto.nombre_referido = '';
        }
    }

    function cambioCheckboxValla() {
        if (data.medio_contacto.valla) {
            data.medio_contacto.ubicacion_valla = '';
        }
    }

    function mostrarImagenes() {
        if (isActive && !isNew && tabsImagenes.length > 0) {
            openSlideoverImagenes = true;
            activeImageTab = tabsImagenes[0].slug;
        }
    }

    function cambiarResponsable() {
        if (isActive) {
            submitData({'seller': data.responsable}, 'post', urlResponsable)
                .then((res) => {
                    alert(res.message);
                    location.reload();
                });
        }
    }

    function save(e) {
        e.preventDefault();
        if (isActive) {
            events('save', data);
        }
    }

    function clienteDesiste() {
        if (!isNew && urlDesiste) {
            events('clienteDesiste', data.informacion_desiste);
            submitData(data.informacion_desiste, 'post', urlDesiste).then(res => {
                alert(res.message);
                location.reload();
            });
        }
    }
</script>

<div>
    <form on:submit={save}>
        <fieldset>
            <legend>RESPONSABLE</legend>
            <div class="grid-2">
                <div class="box-l sx-ii max-w-400px">
                    <NauiSelect label="Responsable"
                                bind:value={data.responsable}
                                options={options.responsable}/>
                    {#if isActive}
                        <NauiButton className="mt-ii" caption="CAMBIAR" color="accent" mode="stroked"
                                    on:click={cambiarResponsable}/>
                    {/if}
                </div>
                {#if !isNew && isActive && data.status > 2}
                    <div class="box-r sx-1">
                        {#if data.status > 4}
                            <NauiButton on:click={() => {
                                console.log('CLICK');
                                events('view');
                            }}
                                        type="button"
                                        caption={viewCaption} mode="outline"
                                        color="accent"/>
                        {/if}
                        <NauiButton href={urlCotizacion} caption="COTIZAR" mode="solid" color="accent"/>
                    </div>
                {/if}
            </div>
        </fieldset>

        {#if isActive && !isNew && !isService}
            <div class="box-l sx-1 pb-2">
                <NauiButton caption="VISITA TELEFÓNICA"
                            color="accent"
                            mode="stroke" on:click={() => {events('phone-visit', data)}}/>
                <NauiButton caption="PROGRAMAR VISITA"
                            color="accent"
                            mode="stroke" on:click={() => {events('visit', {})}}/>
                <NauiButton caption="DESISTE"
                            color="accent"
                            mode="stroke"
                            on:click={()=>{ openSlideoverDesiste = true; }}/>
                <NauiButton caption="VER IMAGENES DEL SERVICIO"
                            color="accent"
                            icon="images"
                            mode="solid"
                            on:click={mostrarImagenes}/>
            </div>
        {/if}

        {#if !isActive}
            <InformacionDesiste bind:data={data.informacion_desiste}/>
        {/if}
        {#if isService && data.legalizacion}
            <Legalizacion serviceProgramming={data.programar_servicio}
                          data={data.legalizacion}
                          observations={data.quote}
                          logistic={logistic}
                          storage={data.servicios.bodega} on:file on:action on:program/>
        {/if}

        <fieldset>
            <legend>DATOS DE CONTACTO</legend>
            <div class="grid-4 gap-15">
                <NauiSelect label="Tipo de cliente"
                            isDisabled={!isActive || !isNew}
                            bind:value={data.contacto.tipo_cliente}
                            options={options.tipo_cliente}/>
                <NauiInput label="Nombre"
                           isDisabled={!isActive}
                           bind:value={data.contacto.nombre}/>
                <NauiInput label="Apellido"
                           isDisabled={!isActive}
                           bind:value={data.contacto.apellido}/>
                <NauiInput label="Correo"
                           type="email"
                           isDisabled={!isActive}
                           bind:value={data.contacto.email}/>
                <NauiInput label="Teléfono 1"
                           isDisabled={!isActive}
                           bind:value={data.contacto.telefono1}/>
                <NauiInput label="Teléfono 2"
                           isDisabled={!isActive}
                           bind:value={data.contacto.telefono2}/>
                <div style="grid-column: span 2">
                    <NauiInput label="Dirección"
                               isDisabled={!isActive}
                               bind:value={data.contacto.direccion}/>
                </div>
            </div>
            {#if data.contacto.tipo_cliente === 'PJ'}
                <div class="grid-2 gap-15 py-15">
                    <NauiInput label="Razón social"
                               isDisabled={!isActive}
                               bind:value={data.contacto.razon_social}/>
                    <NauiInput label="NIT"
                               isDisabled={!isActive}
                               bind:value={data.contacto.numero_documento}/>
                </div>
            {:else}
                <div class="grid-2 gap-15 py-15">
                    <NauiSelect label="Tipo de documento"
                                isDisabled={!isActive}
                                options={options.tipo_documento}
                                bind:value={data.contacto.tipo_documento}/>
                    <NauiInput label="Número de documento"
                               isDisabled={!isActive}
                               bind:value={data.contacto.numero_documento}/>
                </div>
            {/if}
        </fieldset>

        <fieldset>
            <legend>SERVICIOS REQUERIDOS</legend>
            <div class="grid-5 gap-15 my-ii">
                <NauiCheckbox label="Transporte"
                              disabled={!isActive}
                              bind:value={data.servicios.transporte}/>
                <NauiCheckbox label="Embalaje"
                              disabled={!isActive}
                              bind:value={data.servicios.embalaje}/>
                <NauiCheckbox label="Bodega"
                              disabled={!isActive}
                              bind:value={data.servicios.bodega}/>
                <NauiCheckbox label="Materiales vitrina"
                              disabled={!isActive}
                              bind:value={data.servicios.domicilio_cajas}/>
                <NauiCheckbox label="Movimiento de bodegas"
                              disabled={!isActive}
                              bind:value={data.servicios.movimiento_bodegas}/>
            </div>
            <div class="my-ii">
                <NauiDatePicker label="Fecha estimada del servicio"
                                isDisabled={!isActive}
                                bind:value={data.servicios.fecha_estimada}/>
            </div>
            <NauiTextarea label="Observaciones adicionales"
                          isDisabled={!isActive}
                          bind:value={data.servicios.observaciones}/>
            {#if data.visit}
                <NauiTextarea label="Observaciones visita"
                              isDisabled={!isActive}
                              bind:value={data.visit.observations}/>
            {/if}
        </fieldset>

        {#if isService}
            {#if data.servicios.transporte}
                <LogisticaTransporte bind:data={data.logistica_transporte}/>
            {/if}

            {#if data.servicios.embalaje}
                <TipoEmbalaje bind:data={data.tipo_embalaje}/>
            {/if}

            {#if data.servicios.transporte || data.servicios.embalaje}
                <MueblesEspeciales bind:data={data.muebles_especiales} on:verImagenes={mostrarImagenes}/>
            {/if}
            <TamanoServicio bind:data={data.tamano_servicio}/>
        {/if}

        {#if isNew || !isService}
            <fieldset>
                <legend>MEDIO DE CONTACTO</legend>
                <p>¿Cómo llego a Keep & Go?</p>
                <div class="grid-3 gap-15 mt-1">
                    <NauiCheckbox label="Llamada"
                                  disabled={!isActive}
                                  bind:value={data.medio_contacto.llamada}/>
                    <NauiCheckbox label="Búsqueda web"
                                  disabled={!isActive}
                                  on:input={cambioCheckboxBusquedaWeb}
                                  bind:value={data.medio_contacto.busqueda_web}/>
                    <NauiInput label="¿Cómo buscó?"
                               bind:value={data.medio_contacto.como_busco}
                               isDisabled={!isActive || !data.medio_contacto.busqueda_web}/>

                    <NauiCheckbox label="Ha sido / es cliente"
                                  disabled={!isActive}
                                  bind:value={data.medio_contacto.es_cliente}/>
                    <NauiCheckbox label="Referido"
                                  disabled={!isActive}
                                  on:input={cambioCheckboxReferido}
                                  bind:value={data.medio_contacto.referido}/>
                    <NauiInput label="Nombre del referido"
                               bind:value={data.medio_contacto.nombre_referido}
                               isDisabled={!isActive || !data.medio_contacto.referido}/>

                    <NauiCheckbox label="Lead no válido" bind:value={data.medio_contacto.lead_no_valido}/>
                    <NauiCheckbox label="Valla"
                                  disabled={!isActive}
                                  on:input={cambioCheckboxValla}
                                  bind:value={data.medio_contacto.valla}/>
                    <NauiInput label="Ubicación de la valla"
                               bind:value={data.medio_contacto.ubicacion_valla}
                               isDisabled={!isActive || !data.medio_contacto.valla}/>
                </div>
            </fieldset>
        {/if}
        {#if isActive}
            <NauiFloatingAction>
                <NauiButton caption="GUARDAR"
                            icon="save"
                            color="accent"
                            mode="solid"
                            type="submit"/>
            </NauiFloatingAction>
        {/if}
    </form>
    {#if isActive}
        {#if !isNew}
            <Galeria {openSlideoverImagenes} {activeImageTab} {tabsImagenes}/>
            {#if !isNew}
                <DesisteSlideover bind:data={data.informacion_desiste}
                                  bind:open={openSlideoverDesiste}
                                  on:save={clienteDesiste}/>
            {/if}
        {/if}
    {/if}
</div>